import ContentOverlay from "../components/content_overlay";
import "../pages/editors.css";

function EditorsPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Editors</h2>}
      text_content={
        <div className="container innerData">
          <div className="m-0" id="contentMap">
            <div className="my-4">
              <div className="d-flex justify-content-center">
                <div className="container" style={{ textAlign: "center" }}>
                  <p style={{textAlign:"center"}}>
                  <table
                    align="center"
                    
                    cellPadding="10"
                    id="expertTable"
                  >
                    <tbody style={{ textAlign: "center" }}>
                      <tr>
                        <td colSpan="2">
                          <strong>
                            Editorial Team (for Issue 92)
                            <br />
                            Dr. T.V. Ramachandra, Dr N.V Joshi, Dr, M.D Subhash
                            Chandran
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Review</strong>
                        </td>
                        <td>Vinay S, Bharath S, Bharath H Aithal</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Information Compilation</strong>
                        </td>
                        <td>
                          Anjali and Gagana H M
                          <br />
                          Start Date: April 2025 <br />
                          End Date: April 2025
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Design and Developed by</strong>
                        </td>
                        <td>
                          <a
                            style={{ color: "#222", textDecoration: "none" }}
                            href="https://www.linkedin.com/in/abhisbaghel/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Abhishek Baghel
                          </a>
                          &nbsp;and&nbsp;
                          <a
                            style={{ color: "#222", textDecoration: "none" }}
                            href="https://www.linkedin.com/in/bhargava-k-r-971824247/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Bhargava K R
                          </a>
                          <br />
                          Start Date: April 2025
                          <br />
                          End Date: April 2025
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  
                  <strong>
                    The Editors encourage readers to disseminate the information
                    in the newsletter.
                    <br />
                    Information for Contributors
                  </strong>
                  <br />
                  All manuscript should be addressed to
                  <br />
                  <a
                    title="envis.ces@iisc.ac.in"
                    href="mailto:envis.ces@iisc.ac.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    envis.ces@iisc.ac.in
                  </a>
                  ,&nbsp;
                  <a
                    href="mailto:tvr@iisc.ac.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    tvr@iisc.ac.in
                  </a>
                  <br />
                  <strong>
                    Dr. T.V. Ramachandra, Coordinator, ENVIS, Environmental
                    Information System
                    <br />
                  </strong>
                  Centre for Ecological Sciences, New Biological Sciences
                  Building, 3rd Floor, E-Wing, Lab: TE15,
                  <br />
                  Indian Institute of Science, Bangalore 560 012, India
                  <br />
                  Telephone: +91-080-22933099/22933503/23608661 &nbsp;&nbsp;
                  Fax: +91-080-23601428
                  <br />
                  E-mail:&nbsp;
                  <a
                    href="mailto:tvr@iisc.ac.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    tvr@iisc.ac.in
                  </a>
                  ,&nbsp;
                  <a
                    href="mailto:envis.ces@iisc.ac.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    envis.ces@iisc.ac.in
                  </a>
                  <br />
                  Web:&nbsp;
                  <a
                    href="http://wgbis.ces.iisc.ac.in/biodiversity"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    http://wgbis.ces.iisc.ac.in/biodiversity
                  </a>
                  ,&nbsp;
                  <a
                    href="http://wgbis.ces.iisc.ac.in/energy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    http://wgbis.ces.iisc.ac.in/energy
                  
                  </a>
                  </p>

                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
        </div>
      }
    />
  );
}

export default EditorsPage;